export default {
	props: {
		autoOpen:{type:Boolean, default:false},
		autoOpenDelay:{type:Number, default:0},
		autoOpenCloseDelay:{type:Number, default:0},
		btnOk:{type:String, default:''},
		btnOkClass:{type:String, default:'btn btn-ok button outline'},
		btnCancel:{type:String, default:''},
		btnCancelClass:{type:String, default:'btn btn-cancel button fill'},
	},
	data(){
		return {
			isVisible: false,
			isAddedNoScroll: false, //prevent remove no-scroll of parent modal dialog
			closeTimeoutMs: 0, //in milliseconds
			closeTimeoutId: null,
		}
	},
	watch: {
	},
	methods: {
		show(closeTimeoutMs=0){
			this.isVisible = true;
			this.closeTimeoutMs = closeTimeoutMs;
			window.clearTimeout(this.closeTimeoutId);

			window.addEventListener("keydown", this.onKeyDown);

			if(!document.documentElement.classList.contains('no-scroll')){
				this.isAddedNoScroll = true;
				document.documentElement.classList.add('no-scroll');
			}
			this.$emit('show');

			if(this.closeTimeoutMs>0){
				let self = this;
				self.$nextTick(()=>{
					self.$refs.closeTimeoutSpan.style = '';
					window.setTimeout(()=>{
						self.closeTimeoutId = window.setTimeout(function(){ self.hide(); }, self.closeTimeoutMs);
						self.$refs.closeTimeoutSpan.style=`width:100%;transition-duration:${closeTimeoutMs}ms`;
					},1);
				});
			}
		},
		hide(evName='hide'){
			this.isVisible = false;
			this.closeTimeoutMs = 0;
			window.clearTimeout(this.closeTimeoutId);

			window.removeEventListener("keydown", this.onKeyDown);

			if(this.isAddedNoScroll){
				this.isAddedNoScroll = false;
				document.documentElement.classList.remove('no-scroll');
			}

			this.$emit(evName);
		},
		onKeyDown(e){
			if (e.keyCode === 27) {
				window.setTimeout(()=>{ this.hide(); },1);
			}
		}
	},
	mounted(){
		if(this.autoOpen){
			window.setTimeout(()=>{ this.show(this.autoOpenCloseDelay); }, this.autoOpenDelay>0?this.autoOpenDelay:1);
		}
	},
	template: `
<div class="modal show" v-if="isVisible" @click="hide()">
	<div class="modal-scrollable" @click.stop="">
		<div class="modal-content">
			<div class="modal-body button-holder">
				<slot>Modal dialog</slot>
				<div class="modal__row modal-body-btns" v-if="btnOk || btnCancel">
					<button v-if="btnOk" type="button" :class="btnOkClass" @click="hide('ok')">{{btnOk}}</button>
					<button v-if="btnCancel" type="button" :class="btnCancelClass" @click="hide()">{{btnCancel}}</button>
				</div>
			</div>
			<span class="modal-close-btn" @click="hide()"></span>
			<span v-if="closeTimeoutMs>0" class="modal-close-timeout"><span ref="closeTimeoutSpan"></span></span>
		</div>
	</div>
</div>
`,
}
